import type { ReactNode } from 'react';

import { useIsMobile } from '../hooks';
import { DesktopLayout } from './DesktopLayout';
import { MobileLayout } from './MobileLayout';

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileLayout>{children}</MobileLayout>;
  }

  return <DesktopLayout>{children}</DesktopLayout>;
}
